<template>
	<div v-if="damageAssessors == null"></div>
	<BaseCard :title="$t('applied_damage_assessors').toString()" v-else>
		<div class="flex flex-col mb-10">
			<div>
				<div class="m-4" v-if="this.damageAssessors && this.damageAssessors.length <= 0">
					<b>{{ $t('no_available_assessors') }}</b>
				</div>
				<div
					class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
					v-if="this.damageAssessors && this.damageAssessors.length > 0"
				>
					<table class="min-w-full">
						<thead class="w-full" style="height: fit-content;">
							<tr class="">
								<HeaderColumn style="width: fit-content">{{ $t('service_provider') }}</HeaderColumn>
								<HeaderColumn>{{ $t('address') }}</HeaderColumn>
								<HeaderColumn>{{ $t('phone') }}</HeaderColumn>
								<HeaderColumn>{{ $t('e_mail') }}</HeaderColumn>
								<HeaderColumn>{{ $t('status') }}</HeaderColumn>
							</tr>
						</thead>
						<tbody class="bg-white">
							<tr v-for="(damageAssessor, index) in damageAssessors" :key="damageAssessor.id" class="tr odd:bg-gray-200 w-full">
								<td class="px-4 py-4 w-3/12" :class="damageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									<div>{{ damageAssessor.firstName }} {{ damageAssessor.lastName }}</div>
									<div v-if="damageAssessor.company !== null">{{ damageAssessor.company }}</div>
								</td>
								<td class="py-4 w-3/12" :class="damageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ getAddress(damageAssessor) }},
									{{ damageAssessor.city.zip_code }}
									{{ damageAssessor.city.name }}
								</td>
								<td class="py-4 w-1/12" :class="damageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ damageAssessor.phone }}
								</td>
								<td class="py-4 w-3/12" :class="damageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ damageAssessor.email }}
								</td>
								<td class="py-4 w-2/12" :class="damageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ $t('account_applied') }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';

export default {
	name: 'ServiceProviderDamageAssessorApplicationsCard',
	components: { HeaderColumn, BaseCard },
	computed: {
		damageAssessors() {
			if (this.$store.getters.getDamageAssessorApplications === undefined || this.$store.getters.getDamageAssessorApplications.length !== 0) {
				return this.$store.getters.getDamageAssessorApplications;
			} else {
				return null;
			}
		},
	},
	methods: {
		getAddress(company) {
			if (company.street === undefined || company.street === null) {
				return this.$t('po_box') + ' ' + company.poBox;
			} else {
				if (company.houseNumber != null) {
					return `${company.street} ${company.houseNumber || ''}`;
				} else {
					return company.street;
				}
			}
		},
	},
	mounted() {
		this.$store.dispatch('updateDamageAssessorApplications');
	},
};
</script>
